import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PersonalInfo from "../../users/components/PersonalInfo";

interface IProps {
  showUserModal: boolean;
  handleCloseUserModal: () => void;
}
const ModalUser = ({ showUserModal, handleCloseUserModal }: IProps) => {
  const { t } = useTranslation();
  if (!showUserModal) {
    return <></>;
  }
  return (
    <Modal
      show={showUserModal}
      onHide={handleCloseUserModal}
      centered
      size={"lg"}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("user.createUser")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PersonalInfo cancel={handleCloseUserModal} />
      </Modal.Body>
    </Modal>
  );
};

export default ModalUser;
